export default "__VITE_ASSET__6VkRSLFV__"